import { NgModule } from "@angular/core";

// Components
import { RegistrationComponent } from "src/app/modules/registration/components/registration/registration.component";

// Modules
import { SharedModule } from "src/app/modules/shared/shared.module";

// Services
import { RegistrationService } from "src/app/modules/registration/services/registration.service";

@NgModule({
  declarations: [RegistrationComponent],
  imports: [SharedModule],
  exports: [RegistrationComponent],
  providers: [RegistrationService],
})
export class RegistrationModule {}
